import EventEmitter from 'eventemitter3';
import styles from './styles.module.scss';

type DataItem = {
  key: string | number;
  value: unknown;
};

type Token = {
  '--theme-background-color': string;
  '--theme-color': string;
  '--theme-background-color-hover': string;
  '--theme-color-hover': string;
  '--theme-color-selected': string;
  '--theme-background-color-selected': string;
};

type Option = {
  data: DataItem[];
  buttonArray: string[];
  token?: Token;
};

type EventTypes = {
  change: (dataItem: DataItem) => void;
};

let lastOffset = 0;
function handleClick(targetButton: HTMLElement, buttons: NodeListOf<Element>) {
  const outerContainer: HTMLElement = document.querySelector('.js-scrollButtonGroup-outer')!;
  const buttonContainer: HTMLElement = document.querySelector('.js-scrollButtonGroup-buttons')!;

  // 获取容器和按钮的宽度
  const containerWidth = outerContainer.offsetWidth;
  const buttonWidth = targetButton.offsetWidth;
  const buttonsWidth = buttonContainer.scrollWidth;

  // 计算点击按钮的中心位置
  const buttonLeft =
    targetButton.getBoundingClientRect().left - outerContainer.getBoundingClientRect().left;
  const buttonCenter = buttonLeft + buttonWidth / 2;

  // 计算按钮组的偏移量
  let offset = containerWidth / 2 - buttonCenter;

  // 限制偏移量以确保不超出容器范围
  offset = Math.min(0, Math.max(containerWidth - buttonsWidth, offset + lastOffset));
  lastOffset = offset;

  // 应用偏移量
  buttonContainer.style.transform = `translateX(${offset}px)`;

  // 清除所有按钮的"selected" 类
  buttons.forEach(btn => btn.classList.remove(styles.selected));

  // 将点击的按钮添加 "selected" 类
  targetButton.classList.add(styles.selected);
}

export default class ScrollButtonGroup extends EventEmitter<EventTypes> {
  private __$dom!: HTMLElement;

  private __option: Option;

  private __buttonNameArray!: string[];

  private __value!: Option['data'];

  constructor($container: HTMLElement, option: Option) {
    super();

    this.__option = option;
    this.__value = option.data || [];
    this.__$dom = $container;
    this.__buttonNameArray = option?.buttonArray || [];

    this.__initialize();

    this.__bindEvents();
  }

  /** 初始化主题 */
  private __initTheme($dom: HTMLElement) {
    const themeConfig = this.__option.token;
    if (!themeConfig) {
      return;
    }

    Object.keys(themeConfig).forEach(key => {
      $dom.style.setProperty(key, themeConfig[key]);
    });
  }

  private __initialize() {
    const $outer = document.createElement('div');
    $outer.classList.add('js-scrollButtonGroup-outer', styles.outer, styles['theme-container']);
    this.__initTheme($outer);

    const $buttonContainer = document.createElement('div');
    $buttonContainer.classList.add('js-scrollButtonGroup-buttons', styles.buttons);
    $buttonContainer.id = 'js-scrollButtonGroup-buttons';

    const buttonNameArray = this.__buttonNameArray;
    // 生成对应数量的按钮，并默认选择第一个按钮
    buttonNameArray.forEach((name, index) => {
      const $button = document.createElement('div');
      $button.classList.add('js-scrollButtonGroup-button', styles.button);
      $button.textContent = name;
      $buttonContainer.appendChild($button);
      if (!index) {
        $button.classList.add(styles.selected);
      }
    });

    $outer.appendChild($buttonContainer);
    this.__$dom.appendChild($outer);
  }

  private __bindEvents() {
    const self = this;
    const buttons = self.__$dom.querySelectorAll('.js-scrollButtonGroup-button') || [];
    buttons.forEach((button: HTMLElement, index) => {
      button.addEventListener('click', () => {
        handleClick(button, buttons);
        const data = this.__value;
        this.emit('change', data[index]);
      });
    });
  }

  destroy() {
    const self = this;
    const buttons = self.__$dom.querySelectorAll('.js-headButton-button') || [];
    buttons.forEach((button: HTMLElement) => {
      button.removeEventListener('click', handleClick);
    });
    self.__$dom.classList.remove(styles.outer);
  }
}
